export default __webpack_public_path__ + "static/media/rocas_md.83a20cab.png";